import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { CanPaperlessBillingDeactivate } from "../models/CanPaperlessBillingDeactivate";

@Injectable({
  providedIn: "root",
})
export class PaperlessBillingDeactivateGuard
  implements CanDeactivate<CanPaperlessBillingDeactivate>
{
  canDeactivate(
    component: CanPaperlessBillingDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
